<template>
	<div v-show="bodyIsShow">
		<section id="formwrapSection" class="formwrapSection clearfix bac">
		<div class="formwrap">
			<form id="signUpfrom" class="signUpfrom" action="/hmtcj/applyForTcj" method="post">
				<!--<input type="hidden" id="groupbyNum" name="groupbyNum" :value="periodsInfo.id" />
				<input type="hidden" id="position" name="position" value="1" />
				<input type="hidden" id="groupbyType" name="groupbyType" value="1" />-->
				<p class="titleFont">报名可免费领票</p>
				<p class="titleFontZ">注：非报名用户需购票入场20/张</p>
				<div class="sinform">
                    <em class="icon-arror-l"></em>
                    <div @click="getData($event)" class="sinform-text" id="insertCar">请选择意向品牌或车型</div>
                    <div class="icon-arror-r"></div>
                </div>
                <div class="sinform">
                    <em class="signUpfrom-icon signUpfrom-icon01"></em>
                    <input type="text" class="sinform-text" name="usernane" placeholder="请输入姓名" maxlength="10" id="usernane">
                </div>
                <div class="sinform">
                    <em class="signUpfrom-icon signUpfrom-icon02"></em>
                    <input type="tel" autocomplete="off" class="sinform-text" name="Phone" placeholder="请输入手机号码" maxlength="11" id="Phone">
                </div>
                <div class="sub-wrap">
                    <div :class="['singsubmit','tobtn',{'noclick':isclick}]" @click="submitSignup('#usernane','#Phone','#insertCar')" data-track="carfestivalDetailToutiao-1-signUp" id="index-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                        <span class="line">￥20<em></em></span>立即报名
                    </div>
                </div>
				<div style="margin-bottom:1em;color:#999" class="addxyroom">温馨提示,报名即视为同意<a href="javascript:void(0);" class="addxydetail" @click="addxydetail()">《个人信息保护声明》</a> </div>
			</form>
		</div>
		<!-- <agreementComponentQuo></agreementComponentQuo> -->
		</section>
		<!--协议-->
		
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	.titleFont{
		.px2px(font-size, 34px);
		text-align:center;
		color:#fff;
		margin-top:0.93rem;
		margin-bottom:0.2rem;
	}
	.titleFontZ{
		.px2px(font-size, 30px);
		text-align:center;
		color:#b2043f;
		margin-bottom:0.5rem;
	}
	.formwrap{
		width: 10.0rem;
		height: 100%;
	    margin: 0 auto;
	    padding-bottom: 1.5rem;
		background: #1b1880;
	}
	.noclick{
		pointer-events: none;
	}
</style>
<script>
import { Toast } from 'mint-ui';
export default {
	name: 'perfect',
	data:function() {
		return {
			bodyIsShow:false,
			periods:{
				cityId:10,
				successBannerList:[],
				// 已换成真实数据
				improveInfoTextFlag:1,
				// 已换成真实数据
				improveInfoText:"",
				// 已换成真实数据
				improveInfoPicFlag:1,
				// 已换成真实数据
				improveInfoPic:"",
				successBannerCb:false,
				picUrl:""
			},
			abTestFlag:null,
			// 已换成真实数据
			isTicket:null,
			address:null,
			// 已换成真实数据;
			car:null,
			buyway:1,
			buyList:[],
			// 已换成真实数据
			instalments:1,
			brandId:'',
			activityType:'9',            //场次类型
			isclick:false
		}
	},
	mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/carExpo/carExpoSignup.css?v=123"
		});
		document.title="报名页";
		// var applyId = "${applyId}";
	 //    var periodsId = '${periodsId}';
	 //    var sk = '${sk}';
	 //    var leaseCity = '${leaseCity}';
	 //    var lastInstalments = '${lastInstalments}';
	    window.cityId = self.$route.query.cityId;
	    self.periods.cityId =  self.$route.query.cityId;
		getCommonJsIns.initDefaultJS(self.webReady);
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

	    ga('create', 'UA-28316522-1', 'auto');
	    ga('send', 'pageview');

	},
	methods:{
		webReady:function(){
			 // 备份this
			 var self = this;
			 if(self.$route.query.activityType==undefined){
				//
			}else{
				self.activityType=self.$route.query.activityType;
			}
			 this.bodyIsShow = true;
			 var str = (window.location.href).substr((window.location.href).indexOf("?"));
			 
			 if(self.$route.query.brandId != undefined){
			 	$("#insertCar").text(self.$route.query.brandName);
			 	self.brandId=self.$route.query.brandId;
			 }
//			 self.ajaxSubmit.ajax({
//				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applySupplement + str,
//				type:"get",
//				data:{},
//				success:function(data){
//					getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/carfestival/perfectmsg.js",function(){});
//					//数据保存
//					 var result = data.response.result.periods;
//					 var overall = data.response.result;
//					
//					// 判断数据请求状态
//					 if (data.responseHeader.status==200) {
//					 	self.periods.successBannerCb = result.successBannerCb;
//					 	for(var i in result.successBannerList){
//					 		self.periods.successBannerList.push(result.successBannerList[i]);
//					 	}
//				        self.periods.improveInfoTextFlag = result.improveInfoTextFlag;
//				        self.periods.improveInfoText = result.improveInfoText;
//				        self.periods.improveInfoPicFlag = result.improveInfoPicFlag;
//			            self.periods.improveInfoPic = result.improveInfoPic;
//			            self.periods.picUrl =  result.picUrl;
//			            if(overall.abTestFlag){
//			            	self.abTestFlag = overall.abTestFlag;
//			            	console.log(self.abTestFlag);
//			            }
//
//			            if(overall.address){
//			            	self.address = overall.address;
//			            	console.log(self.address);
//			            }
//
//			            if(overall.car){
//			            	self.car = overall.car;
//			            	console.log(self.car);
//			            }
//
//			            self.isTicket = overall.isTicket;
//
//			            self.instalments = overall.instalments;
//					 }
//				},
//				error:function(){}
//			});
//			self.ajaxSubmit.ajax({
//				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.buyWays,
//				type:"get",
//				data:{
//					cityId : self.$route.query.cityId
//				},
//				success:function(data){
//					// 判断数据请求状态
//					 if (data.responseHeader.status==200) {
//					 	self.buyList = data.response.result;
//					 }
//				},
//				error:function(){}
//			});
		},
		getData:function(event){
			var self =this;
			self.brandId='';
          	webCommonUtil.getBrandCarStyle.init({
              domObj:event.target,
              callback:function(){
				//console.log($("#aa").data("carstyleiName"));
              },
              ajaxBrandParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcBrand,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:window.cityId,
                  state:self.activityType,
                }
              },
              ajaxCarStyleParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.baseDataTcStyle,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:window.cityId
                }
              }
            });
     	},
     	addxydetail:function(){
			// $(".xymarsk").show();
			// $(".addxypop-mark").show();
			// $('html').css({
			// 	"overflow-y": "hidden"
			// });
			// $('body', 'html').css({
			// 	"position": "fixed",
			// 	"left": "50%",
			// 	"margin-left": "-5rem",
			// 	"top": 0
			// });
      		agreementUtil.agreement.init();

		},
		checkData:function(name,phone,objId){
			if($(name).val()=='' || !webCommonUtil.commonFun.isName($(name).val())){
				Toast({
                  message: "请填写真实姓名",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if(!webCommonUtil.commonFun.isPhone($(phone).val())){
				Toast({
                  message: "请填写11位手机号码",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if($(objId).data("brandId") == ''|| $(objId).data("carstyleId")==''){
				Toast({
                    message: "请选择品牌和车型",
                    position: 'middle',
                    duration: 2000
                });
                return false;
			}
			else {
				return true;
			}
		},
		subApply:function(data){
			var self = this;
			$("#tikect-sub").attr("disabled","disabled");
			$("#signUpButton").attr("disabled","disabled");
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
				type:"post",
				data:data,
				success:function(data){
					if(data.responseHeader.status == 200){
						$("#tikect-sub").removeAttr("disabled");
						$("#signUpButton").removeAttr("disabled");
						self.isclick=false;
						// console.log(data);
						if(data.response.result.code == 10000) {
//							var c = document.location.href.GetValue("c");
//							if(self.autoShowInfo.tAutoshowPeriodsOcpc != null && c == self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal) {
//								var id = self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
//								if(id != "") {
//									_taq.push({
//										convert_id: id,
//										event_type: "form"
//									});
//								}
//							}
//							trackerAD(data.response.result.applyId);
							//写缓存                           
//							webCommonUtil.cookie.addCookie("tcjphone", $("#telphone").val(), 1);
//							console.log(self.$route.query.groupbyNum+ new Date())
							window.location.href ="/mapply/carExpo/carExpoperfect/suc?applyId=" + data.response.result.result.applyId +"&activityType="+self.activityType+ "&t=" + Date.parse(new Date()) + "&buyway=0&instalments=0&otherbrand=0&periodsId=" + self.$route.query.groupbyNum+"&cityId="+cityId+"&sk="+data.response.result.result.sk+"&cityPy="+self.$route.query.cityPy;
							$("#tikect-sub").removeAttr("disabled");
						} else if(data.response.result.code == -99999) {
							$(".code-warp").show();
						} else {
							Toast({
			                  message: data.response.msg,
			                  position: 'middle',
			                  duration: 2000
			                });
						}

					}
					
				},
				error:function(){
					$("#tikect-sub").removeAttr("disabled");
					$("#signUpButton").removeAttr("disabled");
					self.isclick=false;
					Toast({
	                  message: "系统忙，请稍后",
	                  position: 'middle',
	                  duration: 2000
	                });
				}
			});
			/******增加OCPA统计代码 start******/
			try {
				window.gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});
			} catch (err) {
				console.log(err.message);
			}
			/******增加OCPA统计代码 end******/
		},
     	submitSignup:function(names,phones,objId){
//			$("#js-brand").attr("disabled", "disabled");
//			$("#signUpButton").removeAttr("disabled");
			var self = this;
			var brandType;
			var carType;
//			console.log(self.brandId!=undefined)
			if(self.brandId!=''){
				objId='';
				brandType=self.brandId;
			}else{
				brandType =$(objId).data("brandId");
				carType =$(objId).data("carstyleId");
			}
			
			var buyType = "";
			var splitMoney = "";
			var otherbrand = "";
			var checkStatus;
			checkStatus = self.checkData(names,phones,objId);
//			console.log($(objId).data("brandId"));
//			console.log($(objId).data("carstyleId"));
			if(checkStatus){
				var curWindow = window.location.href;
				var data = {
					"sourceUrl": curWindow,
					"cityId": self.$route.query.cityId,
					"name": $(names).val(),
					"phone": $(phones).val(),
					"groupbyNum": self.$route.query.groupbyNum,
					"groupbyType": self.activityType,
					"buyType": buyType,
					"splitMoney": splitMoney,
					"otherBrand": otherbrand,
					"checkIp": true,
					"noCheckBrandStyle":0,
					"sourceId":'-1',
					"bmtype":'carfair_blue_apply'
				};
				data["brandId"]=brandType;
			   	data["carStyleId"]= carType;
//				if(self.brandId!=undefined){
//					objId='';
//					data["brandId"]=self.brandId;
//				}else{
//					data["brandId"]=$(objId).data("brandId");
//			   	    data["carStyleId"]= $(objId).data("carstyleId");
//				}
				self.isclick=true;
				self.subApply(data);
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carExpo/carExpoSignup.vue